/* Animation nutritional-highlights: CSS transitions triggered by IntersectionObserver. */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isPastTrigger(element, viewportRatio) {
    var rect = element.getBoundingClientRect();
    return rect.top <= window.innerHeight * viewportRatio && rect.bottom >= 0;
  }

  function revealOnce(element, className, viewportRatio, delayMs) {
    if (!element) return;

    var section = element.closest('.nutritional-highlights') || element;
    var reveal = function () {
      if (section.classList.contains(className)) return;

      window.setTimeout(function () {
        section.classList.add(className);
      }, delayMs || 120);
    };

    if (!('IntersectionObserver' in window) || isPastTrigger(element, viewportRatio)) {
      reveal();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal();
          observer.disconnect();
        });
      },
      {
        rootMargin: '0px 0px -' + Math.round((1 - viewportRatio) * 100) + '% 0px',
        threshold: 0
      }
    );

    observer.observe(element);
  }

  function prepareStagger(container, selector, stepMs) {
    container.querySelectorAll(selector).forEach(function (element, index) {
      element.style.setProperty('--nh-anim-delay', index * stepMs + 'ms');
      element.style.setProperty('--nh-line-delay', index * stepMs + 200 + 'ms');
      element.style.setProperty('--nh-marker-delay', index * stepMs + 600 + 'ms');
    });
  }

  function initElement(element) {
    if (element.dataset.animDisabled === 'true') return;

    var section = element.closest('.nutritional-highlights') || element;
    section.classList.remove('nutritional-highlights--in-view', 'nutritional-highlights--callouts-in-view');
    section.classList.add('nutritional-highlights--animate');

    if (prefersReducedMotion.matches) {
      section.classList.add('nutritional-highlights--in-view', 'nutritional-highlights--callouts-in-view');
      return;
    }

    prepareStagger(element, '.nutritional-highlights__item', 150);
    prepareStagger(section, '.nutritional-highlights__callout', 100);

    section.getBoundingClientRect();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        revealOnce(element, 'nutritional-highlights--in-view', 0.7, 120);
        revealOnce(section.querySelector('.nutritional-highlights__callouts-wrapper'), 'nutritional-highlights--callouts-in-view', 0.85, 160);
      });
    });
  }

  function initExistingElements() {
    document.querySelectorAll('nutritional-highlights-anim').forEach(initElement);
  }

  function init() {
    if (customElements.get('nutritional-highlights-anim')) {
      initExistingElements();
      return;
    }

    customElements.define(
      'nutritional-highlights-anim',
      class NutritionalHighlightsAnim extends HTMLElement {
        connectedCallback() {
          initElement(this);
        }
      }
    );

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) initExistingElements();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
